import * as React from 'react';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import { ISitecoreAsset } from "../../shared/models/SitecoreAsset";

interface IButtonData {
  name: string
  link: string
}

interface IProps {
  buttons: IButtonData[];
  name: string;
  ownerId: string;
  horizontal: boolean;
  asset: ISitecoreAsset | undefined;
}

interface IState {
  image: any,
}

class AssetCard extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.getAssetImageUrl = this.getAssetImageUrl.bind(this);
  }
  public getUniqueButtons() {
    const temp: any = [];
    return this.props.buttons.map((b: any) => {
      if (!temp.find((tempb: any) => tempb.name === b.name)) {

        temp.push(b);
        return b;
      }
    })
  }

  public verticalRender() {
    const buttons = this.getUniqueButtons();
    return (
      <div style={{ height: "100%", width: "100%" }}>
        <Card style={{ width: "auto", padding: 8, height: "100%" }}>
          <Grid container direction="column" justify="space-between" style={{ height: "100%", width: "auto" }}>
            <Grid item >
              <Grid container alignItems="flex-start" spacing={8}>
                <Grid item style={{ height: 50 }}>
                  <img
                    style={{ maxHeight: "100%", width: "auto", maxWidth: 60 }}
                    src={this.props.asset ? this.props.asset.createdByIcon : ""}
                  />
                </Grid>
                <Grid item>
                  <Typography variant="caption" >
                    By: <a
                      style={{ color: "grey" }}
                      href={this.props.asset ? (this.props.asset.createdByHyperLink === "" ? process.env.REACT_APP_PUBLIC_WEBSITE_URL : this.props.asset.createdByHyperLink) : undefined}
                    >
                      {this.props.asset ? (this.props.asset.createdBy === "" ? "NxtPort" : this.props.asset.createdBy) : "not specified"}
                    </a>
                  </Typography>
                </Grid>
              </Grid>
              <Divider />

              <Grid item>
                <CardContent >
                  <Grid container justify="flex-start" style={{ height: 200, width: "100%" }}>
                    <div
                      style={{
                        width: "100%",
                        maxWidth: "100%",
                        padding: 0,
                        backgroundImage: "url(" + this.getAssetImageUrl() + ")",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center,center"
                      }}
                      title={(this.props.asset && this.props.asset.title) || ''}
                    />
                  </Grid>
                </CardContent>
              </Grid>
              <CardContent>
                <Typography variant="title" align="center" style={{ fontSize: "1em" }}>
                  {this.props.asset ? this.props.asset.title : this.props.name}
                </Typography>
              </CardContent>
            </Grid>
            <Grid item>
              <Divider />
              <CardActions>
                {buttons.map((button, index) => {
                  return (
                    <div key={index}>
                      {button &&
                        <Link to={button.link}>
                          <Button size="small" color="primary">
                            {button.name}
                          </Button>
                        </Link>
                      }
                    </div>
                  )
                })}

              </CardActions>
            </Grid>
          </Grid>
        </Card>
      </div>
    )
  }

  public horizontalRender() {
    const buttons = this.getUniqueButtons();

    return (
      <div>
        <Card style={{ width: "100%", padding: 0, paddingTop: 4 }}>
          <Grid container justify="space-between" alignItems="stretch">
            <Grid item>
              <Grid container spacing={8} alignItems="center" >
                <Grid item style={{ height: 32, width: 50, padding: 4 }}>
                  <img
                    style={{ width: "auto", maxWidth: "80%", padding: 0, maxHeight: "100%", paddingLeft: "20%" }}
                    src={this.getAssetImageUrl()}
                    title="Port Directory API"
                  />
                </Grid>
                <Grid item>
                  <Typography>
                    {this.props.name}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography color="textSecondary">By:</Typography>
                </Grid>
                <Grid item>

                  <a style={{ color: "grey" }}
                    href={this.props.asset ? (this.props.asset.createdByHyperLink === "" ? process.env.REACT_APP_PUBLIC_WEBSITE_URL : this.props.asset.createdByHyperLink) : undefined}>
                    {this.props.asset ? (this.props.asset.createdBy === "" ? "NxtPort" : this.props.asset.createdBy) : "not specified"}
                  </a>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} />
            <Grid item >
              <CardActions style={{ padding: 0 }}>
                {buttons.map(b => {
                  return (
                    <Button target="_blank" href={b.link} key={b.name} size="small" color="primary">
                      {b.name}
                    </Button>
                  )
                })}
              </CardActions>
            </Grid>
          </Grid>
        </Card>
      </div>
    )
  }

  public render() {
    if (this.props.horizontal) {
      return this.horizontalRender();
    } else {
      return this.verticalRender();
    }
  }

  private getAssetImageUrl() {
    if (this.props.asset && this.props.asset.imageUrl) {
      return this.props.asset.imageUrl;
    } else {
      return process.env.REACT_APP_PUBLIC_WEBSITE_URL + "/-/media/logos/nxtport-logo.png";
    }
  }

}

export default AssetCard;


// WEBPACK FOOTER //
// ./src/modules/consumer/components/AssetCard.tsx